/** A stable identity key for an image row, `requestId/objId`. */
export function imageKey(image: { requestId: string; objId: string }): string {
  return `${image.requestId}/${image.objId}`;
}
